import React from 'react';
import type CustomDevMenuElement from './types';

// eslint-disable-next-line react/jsx-no-useless-fragment
const CustomDevMenu: CustomDevMenuElement = Object.assign(() => <></>, {displayName: 'CustomDevMenu'});

export default CustomDevMenu;
